import React from "react";
import Container from "../components/Container";
import HeaderBanner from "../components/HeaderBanner";
import useLocale from "../locales";
import { Helmet } from "react-helmet";

const TermsOfUse = () => {
  const { textData } = useLocale();
  const termsOfUse = textData?.termsOfUse;
  return (
    <>
      <Helmet>
        <title>GrowLifeFund Terms of Use | User Rules and Usage Guidelines</title>
        <meta
          name="description"
          content="GrowLifeFund’s Terms of Use outline user rules, rights, and responsibilities. Ensure safe, transparent use of our free online financial calculators now"
        />

        {/* Canonical */}
        <link rel="canonical" href="https://growlifefund.com/terms-of-use" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="GrowLifeFund Terms of Use | User Rules and Usage Guidelines"
        />
        <meta
          property="og:description"
          content="GrowLifeFund’s Terms of Use outline user rules, rights, and responsibilities. Ensure safe, transparent use of our free online financial calculators now"
        />
        <meta
          property="og:url"
          content="https://growlifefund.com/terms-of-use"
        />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="GrowLifeFund Terms of Use and user guidelines
"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <Container>
        <div className="my-[24px]">
          <HeaderBanner name={termsOfUse.title} backUrl="/" />

          <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400">
            {termsOfUse.intro1}{" "}
            <a
              href={termsOfUse.href}
              rel="noreferrer"
              target="_blank"
              className="underline text-[#0000FF]"
            >
              {termsOfUse.introLink}
            </a>
            .
          </p>

          <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 mt-[20px]">
            {termsOfUse.intro2}
          </p>

          <ol className="list-decimal pl-[20px] text-gray-font sm:text-[16px] text-[15px] font-lato-medium-500 mt-[20px]">
            {termsOfUse.terms.map((term, index) => (
              <React.Fragment key={index}>
                <h2>
                  <li className={`${index !== 0 ? "mt-[20px]" : ""}`}>
                    {term.title}
                  </li>
                </h2>
                <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400">
                  {term.desc}
                </p>
                {term.list && (
                  <ul className="list-disc pl-[20px] text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400">
                    {term.list.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
              </React.Fragment>
            ))}
          </ol>

          <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 mt-[20px]">
            {termsOfUse.contact}
          </p>
        </div>
      </Container>
    </>
  );
};

export default TermsOfUse;
